export default __webpack_public_path__ + "static/media/curva.3a6d5a5e.png";